// src/utils/utils_channelPurchase.ts
// Point d'entrée unique de l'action « Acheter une chaîne ».
//
// La mécanique (choix du palier si plusieurs sont actifs, ajout au panier, ouverture
// directe du paiement) est partagée entre les 5 ressources CreatorCapacity — voir
// utils_creatorCapacityPurchase.ts. Seule cette fonction est à modifier si le point
// d'entrée change — tous les appelants suivront.

import { buyCreatorCapacity }  from "./utils_creatorCapacityPurchase";

export const BUY_CHANNEL_LABEL = 'Augmenter votre capacité';

/**
 * @param notify  Fonction d'affichage du message. Par défaut window.alert ;
 *                les écrans disposant d'une fenêtre applicative (fiche chaîne…) passent la leur.
 */
export async function openBuyChannel(
  notify: (message: string) => void = (message) => window.alert(message)
): Promise<void> {
  return buyCreatorCapacity(
    'channels',
    "L'achat de chaînes supplémentaires n'est pas encore disponible.",
    '+ de chaînes',
    notify
  );
}
